import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'

const vuexPersist = new VuexPersist({
  key: 'fcvbroker',
  storage: window.localStorage
})

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loading: false,
    auth: null
  },
  mutations: {
    setAuth(state, auth) {
      state.auth = auth.data()
      console.log(auth.data())
    },
    resetAuth(state) {
      state.auth = null
    },
    loadingStart(state) {
      state.loading = true
    },
    loadingStop(state) {
      state.loading = false
    },
  },
  actions: {
  },
  modules: {
  },
  plugins: [vuexPersist.plugin],
})
